import React, { useEffect, useState } from 'react'
import PrimaryButton from '../components/primary-button'
import posts from '../data/posts'
import BasicPageLayout, { BlogPageLayout } from '../layouts/basic-page'
import DB from '../data/db'
import ReactMarkdown from 'react-markdown'
import ReactDom from 'react-dom'
import moment from 'moment'

const Pricing = (props) => {

  



  return (
    <BlogPageLayout >
      <div
        style={{ zIndex: 100, width: "100%", maxWidth: 1050, minHeight: 600, padding: 40}}
      >

        
      </div>

    </BlogPageLayout>
  )
}

export default Pricing
